import { Phone, Mail, MessageCircle, MapPin, Clock } from "lucide-react";
import { COMPANY } from "@/data";
import { Reveal } from "@/components/motion";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  const directs = [
    { icon: Phone, label: "Anrufen", value: COMPANY.phone, href: `tel:${COMPANY.phoneRaw}`, testid: "contact-call" },
    { icon: MessageCircle, label: "WhatsApp", value: "Direkt schreiben", href: COMPANY.whatsapp, testid: "contact-whatsapp" },
    { icon: Mail, label: "E-Mail", value: COMPANY.email, href: `mailto:${COMPANY.email}`, testid: "contact-email" },
  ];

  return (
    <main data-testid="contact-page" className="bg-ink text-white grain">
      <section className="relative z-10 pt-40 pb-16 md:pt-48">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <Reveal>
            <span className="overline text-xs uppercase tracking-[0.3em] text-gold font-medium">Kontakt</span>
            <h1 className="mt-4 font-serif text-5xl md:text-7xl tracking-tight leading-none">
              Kostenlose <span className="text-gold-gradient italic">Besichtigung.</span>
            </h1>
            <p className="mt-6 max-w-xl text-lg text-white/55 font-light">
              Unverbindlich und kostenlos. Wir melden uns schnell mit einem fairen Preisangebot.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative z-10 pb-16">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid sm:grid-cols-3 gap-4">
          {directs.map((d, i) => (
            <Reveal key={d.label} delay={i * 0.08}>
              <a
                href={d.href}
                target={d.href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                data-testid={d.testid}
                className="hover-lift flex items-center gap-4 rounded-2xl border border-white/10 bg-surface p-6 hover:border-gold/40 transition-colors"
              >
                <span className="grid h-12 w-12 place-items-center rounded-full border border-gold/30 text-gold"><d.icon size={20} /></span>
                <div>
                  <p className="text-xs uppercase tracking-[0.15em] text-white/40">{d.label}</p>
                  <p className="text-white">{d.value}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative z-10 pb-24 md:pb-32">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid md:grid-cols-2 gap-14">
          <Reveal>
            <h2 className="font-serif text-3xl md:text-4xl tracking-tight mb-8">Schreiben Sie uns</h2>
            <ContactForm />
          </Reveal>
          <Reveal delay={0.15}>
            <div className="space-y-8">
              <div className="space-y-4">
                <div className="flex gap-4"><MapPin className="text-gold shrink-0" size={20} /><div><p className="text-white/40 text-xs uppercase tracking-[0.15em]">Adresse</p><p>{COMPANY.address}</p></div></div>
                <div className="flex gap-4"><Clock className="text-gold shrink-0" size={20} /><div><p className="text-white/40 text-xs uppercase tracking-[0.15em]">Öffnungszeiten</p><p>{COMPANY.hours}</p></div></div>
                <div className="flex gap-4"><MapPin className="text-gold shrink-0" size={20} /><div><p className="text-white/40 text-xs uppercase tracking-[0.15em]">Einsatzgebiet</p><p>{COMPANY.area}</p></div></div>
              </div>
              <div className="overflow-hidden rounded-2xl border border-white/10">
                <iframe
                  title="Standort Gelnhausen"
                  src="https://www.google.com/maps?q=Gelnhausen&z=10&output=embed"
                  className="h-[320px] w-full grayscale invert-[0.9]"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
